<div
  class="tw-flex tw-row tw-justify-between tw-items-center tw-flex-wrap tw-gap-4 tw-mb-4 people-container">
  <h1 class="content-title tw-items-center tw-mb-0 tw-mt-0">Live Data People</h1>

  <app-credit-usage-indicator></app-credit-usage-indicator>

  <a
    target="_blank"
    href="https://docs.gotlivedata.com/docs/people-api#/"
    class="tw-flex tw-items-center tw-gap-1 tw-font-medium tw-text-link-color-dynamic-darker tw-text-sm hover:tw-underline tw-ml-auto">
    <mat-icon class="info-icon tw-h-4 tw-w-4">school</mat-icon>
    Learn about the People API
  </a>
</div>

<div class="content tw-flex-col">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a mat-tab-link routerLinkActive="active-tab-nav" routerLink="./details" class="tw-text-base">
      Search
    </a>
    <a mat-tab-link routerLinkActive="active-tab-nav" routerLink="./filters" class="tw-text-base">
      Explore
    </a>
    <a
      *ngIf="isAdmin | async"
      mat-tab-link
      routerLinkActive="active-tab-nav"
      routerLink="./find"
      class="tw-text-base">
      <mat-icon class="tw-mr-2 tw-w-4 tw-h-4 tw-text-base tw-leading-none">construction</mat-icon
      >Find
    </a>
    <a
      *ngIf="isAdmin | async"
      mat-tab-link
      routerLinkActive="active-tab-nav"
      routerLink="./find-companies"
      class="tw-text-base">
      <mat-icon class="tw-mr-2 tw-w-4 tw-h-4 tw-text-base tw-leading-none">construction</mat-icon
      >Find Companies
    </a>
  </nav>
  <div mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </div>
</div>
